export default "__VITE_ASSET__BqI7XNXy__"